import React from 'react';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';

function NotInLiveMode({ cancelChat, t }) {
  return (
    <Popover onCloseButtonClick={ cancelChat } closable closeOnBackdropClick isOpen className={ classes.notInLiveModePopover }>
      <div className={ classes.notInLiveModeContainer }>
        { t('advisor_cannot_accept_the_chat_now') }
      </div>
    </Popover>
  );
}

export default NotInLiveMode;
